import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ValidationService } from '../../shared/providers/validation.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { IPropertyCard } from '../../shared/models/propertycard';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from '../../shared/providers/loader.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IExchangeCodeOutputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { Trade1031Service } from '../../shared/providers/Trade1031.service';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../shared/providers/toast.service';
import { CommonService } from '../../shared/providers/common.service';
import { IInsights } from '../../shared/models/Insights';
import { AuthService } from '../../shared/auth/auth.service';
import { Subscription } from 'rxjs';

export enum Tabs {
  RecentFeeds = 1,
  Insights = 2
}

@Component({
  selector: 'app-principal-dashboard',
  templateUrl: './principal-dashboard.component.html',
  styleUrls: ['./principal-dashboard.component.css']
})
export class PrincipalDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('SellerDashboardNoAccess') sellerDashboard: TemplateRef<any>;
  @ViewChild('PrincipalDashboardNoAccess') Dashboard1031: TemplateRef<any>;

  constructor(private _trade1031Service: Trade1031Service, public Validation: ValidationService, public router: Router, private _propertyManagerService: PropertyManagementService, public authentication: AuthenticationService
    , private Loader: LoaderService, private UserManager: UserManagerService, private _auth0: AuthService, private modalService: BsModalService, private Toast: ToastService
    , private _commonService: CommonService
  ) { }
  user: any;
  private _subscriptions: Subscription[] = [];
  public currentSourcePage: string = 'principal-dashboard';
  properties: IPropertyCard[] = [];
  sellerId: any;
  tabs = Tabs;
  currentTab = Tabs.RecentFeeds;
  hasSellerDashboardAccess: boolean
  modelRefSellerDashboard: BsModalRef;
  modalRef1031Dashboard: BsModalRef;
  modalMyPortfolioAccess: BsModalRef;
  selectedExchange: number = 0;
  noData: boolean
  has1031DashboardAccess: boolean;
  exchangeCodes: IExchangeCodeOutputModel[];
  Trade1031: string
  WPSiteUrl = environment.WPsiteurl;
  userAddedToWaitList: boolean
  disbleWaitListButton: boolean = false;
  Insights: IInsights[]
  IsMyPortfolioEnabled: boolean = false;

  ngOnInit(): void {
    this.Loader.display(true);
    this.user = this.authentication.user;
    this.getFeaturedListingProperties();
    this.sellerId = this.user.Id;
    this.CheckUserAddedToWaitList();
    this.checkSellerDashboardAccess();
    this.bindExchange();
  }

  async getFeaturedListingProperties() {
    this.Loader.display(true);
    this._subscriptions.push(await this._propertyManagerService.GetFeaturedProperties(this.user.Id).subscribe(response => {
      this.properties = response;
    }));
    this.Loader.display(false);
  }

  ngOnDestroy() {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  onTabClick(tab) {
    this.currentTab = tab;
    this.router.navigateByUrl(this.Validation.changeQueryStringValue('activetab', tab));

    if (tab == this.tabs.Insights) {
      this.bindInsights();
      var element = document.getElementById("dashboard-insights");
      this.scrollToTop(element, 200);
    //  window.scrollTo(600, 800);
    }
  }
  scrollToTop(element, offset) {
    //this.scrollService.scrollTo(element, offset);
    $('html,body').animate({ scrollTop: ($(element).offset().top - offset) }, 500);
  }
  async checkSellerDashboardAccess() {
    this.Loader.display(true);
    this._subscriptions.push(await this.UserManager.GetUserBasicInfo(null, this.sellerId).subscribe(response => {
      let userInfo = response;
      if (userInfo["IsSellerDashboardEnabled"]) {
        this.hasSellerDashboardAccess = true;
        this.Loader.display(false);
      }
      else {
        this.hasSellerDashboardAccess = false;
        this.Loader.display(false);
      }
      this.IsMyPortfolioEnabled = (response != null && response["IsMyPortfolioEnabled"] != undefined) ? response["IsMyPortfolioEnabled"] : false;
    }));
  }

  sellerDashboardBtnClick() {
    if (this.hasSellerDashboardAccess) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/seller/dashboard'], { queryParams: { fromMenu: 'PrincipalDashboard' } }));
      this._auth0.openMenuinHeader.next('sell');
    }
    else {
      this.modelRefSellerDashboard = this.modalService.show(this.sellerDashboard, { class: 'principaldashboard' });
    }
  }

  principalDashboardBtnClick() {
    if (this.has1031DashboardAccess) {
      this.router.navigate(['/dashboard-1031/'], { queryParams: { fromMenu: 'PrincipalDashboard' } });
      this._auth0.openMenuinHeader.next('exchangeDashboard1031');
    }
    else {
      this.Trade1031 = '';
      this.modelRefSellerDashboard = this.modalService.show(this.Dashboard1031, { class: 'principaldashboard' });
    }
  }

  async bindExchange() {
    this.Loader.display(true);
    this._subscriptions.push(await this._trade1031Service.GetExchangeCode(this.sellerId).subscribe(res => {
      this.exchangeCodes = res.filter(x => x.ShowDashboard);
      if (this.exchangeCodes.length <= 0) {
        this.has1031DashboardAccess = false;
        this.Loader.display(false);
      }
      else {
        if (this.authentication.Principal1031()) {
          this.has1031DashboardAccess = true;
        }
        else {
          this.has1031DashboardAccess = false;
        }
        this.Loader.display(false);
      }
    }));
  }

  AddToWishList() {
    this.Loader.display(true);
    this.UserManager.AddToWaitList(this.sellerId).subscribe(response => {
      if (!response) {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Some Error Occured Please try again", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        this.Toast.addToast({ title: 'Success', msg: 'Successfully added to the waitlist', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.disbleWaitListButton = true;
        this.CheckUserAddedToWaitList();
      }
    });
    this.Loader.display(false);
  }

  async CheckUserAddedToWaitList() {
    this.Loader.display(true);
    this._subscriptions.push(await this.UserManager.CheckIfUserAddedToWaitList(this.sellerId).subscribe(response => {
      if (!response) {
        this.disbleWaitListButton = false;
        this.userAddedToWaitList = false;
        this.Loader.display(false);
      }
      else {
        this.disbleWaitListButton = true;
        this.userAddedToWaitList = true;
        this.Loader.display(false);
      }
    }));
  }

  async bindInsights() {
    this.Loader.display(true);
    this._subscriptions.push(await this._commonService.GetInsights().subscribe(response => {
      if (response) {
        this.Insights = response
        this.Loader.display(false);
      }
    }));

  }

  InterestCriteriaBtnClick() {
    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    this.router.navigate(['/my-profile'], { queryParams: { user: loggedUserDetails.Guid.toString(), previouspage: 'PrincipalDashboard' } });
  }

  OnClickPortfolio() {
    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: loggedUserDetails.Guid.toString(), opentab: '1' } });
    this._auth0.openMenuinHeader.next('MyPortfolio');
  }

  OnClickMyPortfolioAccess(template: TemplateRef<any>, classes: any) {
    this.modalMyPortfolioAccess = this.modalService.show(template, { class: classes });

  }
  ApproveMyPortfolio() {
    this.Loader.display(true);
    this.modalMyPortfolioAccess.hide();
    this.UserManager.EnableMyportfolio(this.sellerId).subscribe(response => {
      if (!response) {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Some Error Occured Please try again", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        this.Loader.display(false);
      }
      else {
        this.Toast.addToast({ title: 'Success', msg: 'Your request has been successfully submitted. The B+E team will get in touch with you shortly', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.Loader.display(false);
      }
    });
  }

}
